import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import DoctorLayout from "@/pages/doctor/DoctorLayout";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/date";
import { Button } from "@/components/ui/button";
import PrescriptionPDF from "@/components/PrescriptionPDF";
import { Printer } from "lucide-react";

export default function PrescriptionPrintPage() {
  const { prescriptionId } = useParams();
  const navigate = useNavigate();
  const [prescription, setPrescription] = useState(null);
  const [patient, setPatient] = useState(null);

  useEffect(() => {
    api.get(`/prescriptions/${prescriptionId}`).then(async ({ data }) => {
      setPrescription(data);
      const { data: p } = await api.get(`/patients/${data.patient_id}`);
      setPatient(p);
    });
  }, [prescriptionId]);

  if (!prescription || !patient) return <DoctorLayout><p className="text-slate-500">Loading...</p></DoctorLayout>;

  return (
    <DoctorLayout>
      <h1 className="text-2xl font-semibold text-slate-900" data-testid="prescription-print-heading">
        Prescription — {patient.full_name}
      </h1>
      <p className="mt-1 text-sm text-slate-500">Saved on {formatDateTime(prescription.created_at)}</p>
      <div className="mt-6 flex gap-3">
        <PDFDownloadLink document={<PrescriptionPDF patient={patient} prescription={prescription} />} fileName={`${patient.patient_code}_prescription.pdf`}>
          {({ loading }) => (
            <Button data-testid="download-prescription-pdf-btn" className="gap-2 bg-teal-700 hover:bg-teal-800">
              <Printer className="h-4 w-4" /> {loading ? "Preparing PDF..." : "Download PDF"}
            </Button>
          )}
        </PDFDownloadLink>
        <Button variant="outline" onClick={() => navigate(-1)}>Back</Button>
      </div>
    </DoctorLayout>
  );
}
